module.exports = __webpack_public_path__ + "img/logo@2x.e5e6e363.png";